(function (app) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Determine",
        {
            url: "/{transactionId}/Determine",
            template: "<ui-view />",
            redirectTo: "Transaction.Determine.ProductChoice",
            resolve: {
                transaction: ["transactionApi", "$transition$", function (transactionApi, $transition$) {
                    return transactionApi.get($transition$.params().transactionId);
                }]
            }
        });
    }]);

})(window.app); //jshint ignore:line